import { render, staticRenderFns } from "./CustomerPaymentList.vue?vue&type=template&id=1c977d76"
import script from "./CustomerPaymentList.vue?vue&type=script&lang=js"
export * from "./CustomerPaymentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports